import {createSelector} from 'reselect';
import { groupBy } from 'lodash';

const getValueRealizedAnalysisGoals = (state) => {
  return state && state.dsaConfig && state.dsaConfig.valueRealizedAnalysisGoals || [];
};

const getValueRealizedAnswers = (state) => {
  return state && state.dsa.dsaValueRealized || [];
};

const getValueRealizedAnalysisGoalSubAreas = (state) => {
  return state && state.dsaConfig && state.dsaConfig.valueRealizedAnalysisGoalSubAreas || [];
};

const getSubAreas = (state) => {
  return state && state.dsaConfig && state.dsaConfig.subAreas || [];
};

function findAnswer(sa, answers) {
  let value;

  const vra = answers.find(a => a.valuerealized === sa.valuerealized) || { answer: 0 };

  switch (sa.calculation) {

    case 'businessImpact': {
      const vra2 = answers.find(a => a.valuerealized === sa.valuerealized2) || { answer: 0 };

      let c = vra.answer / 100 || 0;
      let d = vra2.answer / 100 || 0;

      value = (((1 - d) * 0.8 * c) + (d)) * 100;
      break;
    }

    default: {
      value = vra.answer === null ? 0 : vra.answer;
      break;
    }
  }

  return Object.assign({}, sa, {value: value });
}

function findPrintTitle(sa, titles) {
  const subareaTitle = titles.find( (t) => {
    return t.id === sa.subarea;
  });
  return Object.assign({}, sa, { title: subareaTitle.title });
}

function populateSubarea(vr, subAreas) {
  const goalSubAreas = subAreas.filter( (sa) => {
    return sa.valuerealizedanalysisgoal === vr.id;
  });
  return Object.assign({}, vr, {values: goalSubAreas});
}

function sumTotal(a, v) {
  return a + v.value;
}

function populateTotal(vr) {
  const calculateTotal = vr.values.reduce(sumTotal, 0) / vr.values.length;
  return Object.assign({}, vr, {values: vr.values.concat([{title: 'Total', value: calculateTotal }])});
}

const getValueRealized = createSelector(
  [getValueRealizedAnalysisGoals, getValueRealizedAnswers, getValueRealizedAnalysisGoalSubAreas, getSubAreas],
  (vraGoals, vrAnswers, vraGoalsSubAreas, subAreas) => {

    const subAreaAnswers =
      vraGoalsSubAreas
        .map(sa => findAnswer(sa, vrAnswers))
        .map(sa => findPrintTitle(sa, subAreas));

    return vraGoals
      .map(vr => populateSubarea(vr, subAreaAnswers))
      .map(populateTotal)
      .map((vr) => {
          return {
            id: vr.id,
            area: vr.area,
            title: vr.title,
            order: vr.order,
            benchmarkLow: (vr.low),
            benchmarkHigh: (vr.high),
            values: vr.values
          };
        });

  }
);

export const getValueRealizedByArea = createSelector(
  [getValueRealized],
  (valueRealized) => {
    return groupBy(valueRealized, item => item.area);
  }
);

export const getValueRealizedForArea = (state, props) => {
  const valueRealized = getValueRealizedByArea(state);
  return valueRealized[parseInt(props.params.areaId)];
};

export const getChartFormattedValueRealized = createSelector(
  [getValueRealized],
  (valueRealized) => {
    return valueRealized.map(item => {
      const value = item.values.filter((v) => v.title === 'Total').slice(0)[0];
      const indexOfSeparator = item.title.search('by an (average|avg) of');

      const id = item.id;
      const area = item.area;
      const inPlaceCurrent = `${value.value.toFixed(0)}%`;
      const efficiencies =
        indexOfSeparator > 0 ?
        item.title.substring(0, indexOfSeparator) :
        item.title;
      const benchmarks =
        (item.benchmarkHigh > 0 && item.benchmarkLow > 0) ?
        `${item.benchmarkLow * 100} - ${item.benchmarkHigh * 100}%` :
        'N/A';

      return {
        id,
        area,
        inPlaceCurrent,
        efficiencies,
        benchmarks
      };
    });
  }
);

export const getChartFormattedValueRealizedByArea = createSelector(
  [getChartFormattedValueRealized],
  (valueRealized) => {
    return groupBy(valueRealized, item => item.area);
  }
);

export const getChartFormattedValueRealizedForArea = (state, areaId) => {
  const valueRealized = getChartFormattedValueRealized(state);
  return valueRealized.filter(item => item.area === areaId);
};



// WEBPACK FOOTER //
// ./src/selectors/analytics/valueRealizedSelectors.js